export const LantixMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lantix-grad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#8c52ff" />
        <stop offset="1" stopColor="#2b0086" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13" fill="url(#lantix-grad)" />
    <path
      d="M24 9c1.6 8.2 6.8 13.4 15 15-8.2 1.6-13.4 6.8-15 15-1.6-8.2-6.8-13.4-15-15 8.2-1.6 13.4-6.8 15-15Z"
      fill="#f3f3f3"
    />
    <circle cx="24" cy="24" r="3.2" fill="#42f68f" />
  </svg>
);

export const Spark = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 1.5c.8 4.2 3.5 6.9 7.7 7.7-4.2.8-6.9 3.5-7.7 7.7-.8-4.2-3.5-6.9-7.7-7.7 4.2-.8 6.9-3.5 7.7-7.7Z" />
    <path d="M19 15.4c.4 2 1.7 3.3 3.7 3.7-2 .4-3.3 1.7-3.7 3.7-.4-2-1.7-3.3-3.7-3.7 2-.4 3.3-1.7 3.7-3.7Z" />
  </svg>
);

export default function Logo({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="logo-home-button"
      className="flex items-center gap-2.5 group"
      aria-label="Lantix home"
    >
      <span className="transition-transform duration-500 group-hover:rotate-180">
        <LantixMark size={34} />
      </span>
      <span className="font-brand font-bold tracking-[0.14em] text-lg text-brand-paper">
        LANTIX
      </span>
    </button>
  );
}
